import LineOrange from "../../../common/LineOrange/LineOrange";

export const ApplicationOfTheCertificate = (src) => {
  return (
    <>
      <div
        style={{ minHeight: "50vh", backgroundColor: "#F2F4F6" }}
        className="d-flex justify-content-center align-items-center"
      >
        <div className="container">
          <div className="title d-flex flex-column">
            <h3 className="text-right mt-5">مزایای پذیرش در بورس</h3>
            <LineOrange />
          </div>
          <div
            className="d-flex  align-items-center justify-content-center mb-5"
            style={{ minHeight: "50vh" }}
          >
            <div className="row align-items-center w-100 ">
              <div className="col-12 col-lg-7">
                <ul className="text-right mt-3">
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    تجهیز پس‌اندازها و منابع‌ مالی‌ کوچک‌ مردم براي انجام طرحهاي
                    بزرگ
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    رشد و توسعه‌ اقتصادي کشور
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    تخصیص‌ بهینه‌ سرمایه‌
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    افزایش‌ ثروت و رفاه اقتصادي جامعه‌{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    کنترل حجم‌ نقدینگی‌ اقتصاد و آثار ضد تورمی‌{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    رشد تولید ناخالص‌ ملی‌ و افزایش‌ اشتغال
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    گسترش عدالت‌ اجتماعی‌ از طریق‌ فراهم‌ نمودن توزیع‌ عادلانه‌
                    ثروت{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    مردم سالاري اقتصادي از طریق‌ گسترش مالکیت‌ و ایجاد احساس
                    مشارکت‌ عمومی‌
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    نظارت عمومی‌ بر شرکت‌ها
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    گسترش اقتصاد بازار محور
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    کمک‌ به‌ افزایش‌ آهنگ‌ رشد پس‌انداز و سرمایه‌گذاري
                  </li>
                </ul>
              </div>
              {/* <div className="col-12 col-lg-6">
                <div className="text-center">
                  <img
                    src={"/asset/images/02.png"}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
